import { FunctionComponent } from 'react';

// utils
import classnames from 'classnames';

// Components
import ImgLazy from '@Components/Utils/Lazy/Image';
import Image from '@Components/Utils/Image';

// styles

import styles from './DownloadApp.module.scss';
import Anchor from '@Components/Utils/Anchor';

interface DownloadAppProps {
    title?: string;
    className?: string;
    deviceType?: string;
}

const DownloadApp: FunctionComponent<DownloadAppProps> = ({ title, className, deviceType }) => {
    const classNames = classnames([styles.Download_app_wrapper, className]);
    return (
        <>
            <div className={classNames}>
                <div className={styles.title}>{title}</div>
                <div className={styles.content}>
                    <Anchor
                        href="https://apps.apple.com/vn/app/edoctor-know-your-health/id1041327503"
                        className={styles.app_item}
                        tracking={{ action: 'user_click_download' }}
                    >
                        {['mobile', 'tablet'].includes(deviceType) ? (
                            <ImgLazy
                                alt="eDoctor - App Store"
                                width={140}
                                height={45}
                                className={styles.app_icon}
                                src="/assets/app_store.png"
                            />
                        ) : (
                            <Image
                                alt="eDoctor - App Store"
                                width={140}
                                height={45}
                                className={styles.app_icon}
                                src="/assets/app_store.png"
                            />
                        )}
                    </Anchor>

                    <Anchor
                        href="https://play.google.com/store/apps/details?id=vn.edoctor.userapp"
                        className={styles.app_item}
                        tracking={{ action: 'user_click_download' }}
                    >
                        {['mobile', 'tablet'].includes(deviceType) ? (
                            <ImgLazy
                                alt="eDoctor -  Google Play"
                                width={140}
                                height={45}
                                className={styles.app_icon}
                                src="/assets/google_play.png"
                            />
                        ) : (
                            <Image
                                alt="eDoctor -  Google Play"
                                width={140}
                                height={45}
                                className={styles.app_icon}
                                src="/assets/google_play.png"
                            />
                        )}
                    </Anchor>
                </div>
            </div>
        </>
    );
};

DownloadApp.defaultProps = {
    className: '',
    title: 'Tải ứng dụng để nhận thông báo Tin tức sức khỏe mới nhất',
};

export default DownloadApp;
